

export const Spanish = {

    MODULE: {
        LABEL: "Acceso",
    },

    LOGIN: {
        SEO_TITLE: "Iniciar sesión",
        SEO_DESCRIPTION: "Acceso privado a NOTEBOOK.",
        STATUS: "NOTEBOOK PRIVADO",
        EYEBROW: "Tu espacio personal",
        TITLE: "Bienvenido",
        TITLE_ACCENT: "de vuelta.",
        DESCRIPTION: "Proyectos, biblioteca, finanzas, credenciales y notas. Todo en un solo lugar privado.",
        CARD_EYEBROW: "Acceso privado",
        CARD_TITLE: "Iniciar sesión",
        CARD_SUBTITLE: "Ingresá con tu correo y contraseña.",
        SUBMIT: "Ingresar",
        SUBMIT_LOADING: "Verificando",
    },

    FIELDS: {
        EMAIL_LABEL: "Correo electrónico",
        EMAIL_PLACEHOLDER: "tucorreo@dominio.com",
        PASSWORD_LABEL: "Contraseña",
        PASSWORD_PLACEHOLDER: "Tu contraseña",
        REMEMBER_ME: "Recordarme",
    },


};
